import { GeoJsonLayer } from '@deck.gl/layers/typed';
import { PickingInfo } from '@deck.gl/core/typed';
import { MjolnirGestureEvent } from 'mjolnir.js';
import { useMemo } from 'react';
import { useMapTooltipContext } from '../../contexts/MapTooltipProvider';
import { KineticFeature } from '../types';

export const useGeoJsonLayer = ({
  geoJson,
  onClick,
}: {
  geoJson: KineticFeature[];
  onClick: (info: PickingInfo, event: MjolnirGestureEvent) => void;
}) => {
  const { hovered, onHover } = useMapTooltipContext();
  const geoJsonLayer = useMemo(
    () =>
      new GeoJsonLayer({
        id: 'geojson',
        data: geoJson,
        pickable: true,
        getFillColor: (feature) => feature.properties?.fillColor,
        getLineColor: (feature) => feature.properties?.lineColor ?? 'black',
        getLineWidth: (feature) => feature.properties?.lineWidth ?? 1,
        onHover,
        onClick: (info, e) => onClick(info, e as MjolnirGestureEvent),
        lineWidthMinPixels: 4,
        order: 2,
      }),
    // watch hoverInfo too
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [geoJson, hovered]
  );

  return { geoJsonLayer };
};
